export function validateSingleFieldOnBlur(errors, schema, name, formRef) {
  try {
    const formData = formRef.current.getData();

    // Get the field schema from the main schema
    const fieldValue = formData[name];

    // Try to validate just this field by creating a partial object
    // and using safeParse to avoid throwing errors
    const partialData = { [name]: fieldValue };
    const result = schema.safeParse(partialData);

    // Other required fields are absent from this partial object, so the parse
    // will often fail even when this specific field is valid — only look at
    // whether THIS field has an error, not the overall partial result.
    const fieldError = result.success
      ? undefined
      : result.error.errors.find((error) => error.path[0] === name);

    formRef.current?.setErrors({
      ...errors,
      [name]: fieldError ? fieldError.message : undefined,
    });
  } catch (err) {
    // If something goes wrong, just clear the error
    formRef.current?.setErrors({
      ...errors,
      [name]: undefined,
    });
  }
}
